// Component: IconGridCard
// Author: Jay
import React from 'react';
import { Text, Image, withPlaceholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Card from '@component/IconGridCard';
import WBRString from '@component/WbrString';
import { RoutableLink } from '../../react/RoutableLink';
import EditableLink from '../../react/EditableLink';

const IconGridCard = (props) => {
  const links = [];

  const isEditing = props.sitecoreContext && props.sitecoreContext.pageEditing;

  props.fields?.children?.forEach((link, index) => {
    let l = (
      <>
        <RoutableLink field={link.fields?.Link} key={index} useATag={true}>
          <WBRString tag="span">
            <Text field={link.fields?.LinkText} />
          </WBRString>
        </RoutableLink>
        <EditableLink linkField={link.fields?.Link} isEditing={isEditing} />
      </>
    );

    if (link?.fields?.LinkText?.value !== '' && link?.fields?.Link?.value?.href !== '') {
      links.push(l);
    }
  });

  return (
    <>
      <Card
        image={<Image field={props.fields?.Image} editable={true} />}
        title={<Text field={props.fields?.Title} />}
        text={<Text field={props.fields?.Text} />}
        links={links}
      />
    </>
  );
};

const compWithPlaceholder = withPlaceholder('Icon-Grid-Card')(IconGridCard);
const compWithSitecoreCtx = withSitecoreContext()(compWithPlaceholder);

export default compWithSitecoreCtx;
